module.exports = __webpack_public_path__ + "static/LucasPope5-bc42ce5e2854146bb479148b73b208cb.png";